import React, { useEffect, useState } from 'react'
import MobileNavigation from '../Navigation/MobileNavigation'
import { getBreadCrumbs } from '../../../../utils/utils'
import { getLinkType } from '../../../../utils/linkUtil'
import { Popover } from '../../../Compounds/src/Popover'
import AMPLOGO from '../../../../../assets/images/Ameriprise_Financial_logo.jpg'
import { HeaderProps } from './Header.types'
import { BreadCrumbs, Menu, UtilityNavigation } from '../data/data.types'
import './App.scss'

export const Header = ({
  headerDocument,
  mainMenu,
  backgroundColor,
  textColor,
  menuIconColor,
  layoutClass,
  dropdownOptions,
  mobileButton,
}: HeaderProps) => {
  const headerLogo =
    window?.AMPMSSITEPATH?.length > 2
      ? window.AMPMSSITEPATH + 'images/shared/Ameriprise_Financial_logo.jpg'
      : AMPLOGO
  const [popover, setPopover] = useState(false)

  const { desktopImage, siteName, siteNameHref, utilityNavigation } = headerDocument ?? {}
  let breadCrumbs: BreadCrumbs | undefined = undefined
  let menuItems: Menu[] = []
  if (mainMenu?.data?.menuItems) {
    const { data } = mainMenu
    menuItems = data.menuItems
    breadCrumbs = getBreadCrumbs(menuItems)
  }

  const handlePopoverClick = () => {
    const newPopoverValue: boolean = !popover
    const docBody = document.querySelector('body')
    if (docBody) {
      if (newPopoverValue) {
        docBody.style.overflow = 'hidden'
      } else {
        docBody.style.overflow = 'auto'
      }
    }
    setPopover(newPopoverValue)
  }
  useEffect(() => {
    const handleWindowSizeChange = () => {
      if (window.innerWidth >= 1025 && popover) {
        handlePopoverClick()
      }
    }
    window.addEventListener('resize', handleWindowSizeChange)
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [popover])
  const buildNavItems = (navItems: UtilityNavigation[]) => {
    return (
      <>
        {navItems.map(item => {
          const customClasses = item.classes
            ? item.classes.reduce((att, curr) => {
                return `${att} ${curr}`
              }, '')
            : ''
          if (item.linkType === 'phone') {
            return (
              <a
                href={item.linkHref ? `tel:${item.linkHref}` : '#'}
                aria-label={item.text}
                target={item.target}
                key={item.text}
                className={`${getLinkType(
                  item.linkType
                )} ${customClasses} u-linkClean u-md-hidden u-sm-hidden`}
                data-analytics={item.analytics}>
                {item.icon === 'phone' && (
                  <i>
                    <span
                      aria-hidden='true'
                      className='Icon u-textInheritColor u-textSizeMsrp1 u-alignMiddle u-marginRight1gu'>
                      &#xe0cd;
                    </span>
                    <span className='u-hiddenVisually'>Phone number</span>
                  </i>
                )}
                {item.text}
              </a>
            )
          }
          return (
            <a
              href={item.linkHref}
              aria-label={item.text}
              target={item.target}
              key={item.text}
              className={`${getLinkType(
                item.linkType
              )} ${customClasses} u-linkClean u-md-hidden u-sm-hidden`}
              data-analytics={item.analytics}>
              {item.icon === 'secure' && (
                <i className='Icon icon-shield u-marginRight1gu' aria-hidden='true'></i>
              )}
              {item.text}
            </a>
          )
        })}
      </>
    )
  }

  const getRightSideContent = () => {
    if (headerDocument && utilityNavigation?.length) {
      return buildNavItems(utilityNavigation)
    }
    if (dropdownOptions) {
      return (
        <Popover
          items={dropdownOptions.items}
          currentDisplayIndex={dropdownOptions.currentDisplayIndex}
          hiddenMessage={dropdownOptions.hiddenMessage}
        />
      )
    }
    if (!utilityNavigation?.length) {
      return (
        <>
          <a
            href='/privacy-security-fraud/online-security-guarantee'
            data-analytics='OnlineSecurityURL'
            className='Link u-linkClean u-flex u-flexAlignItemsCenter'>
            <span
              className='adel-material-symbols-16 u-marginRight1gu'
              aria-hidden='true'
              role='img'>
              security
            </span>
            Online security guarantee
          </a>
          <div className='pipe--Divider u-posRelative' />
          <a
            href='/customer-service'
            data-analytics='CustomerServiceUrl'
            className='Link u-linkClean'>
            Customer service
          </a>
        </>
      )
    }
    return null
  }
  return (
    <>
      <header
        id='StandardHeader'
        className={`${
          layoutClass ? 'u-paddingRight3gu u-sm-paddingLeft3gu u-md-paddingLeft3gu' : ''
        } u-paddingVert3gu ${backgroundColor} ${textColor}`}>
        <div className={layoutClass || 'u-sizeConstrained'}>
          <div className='amp-header-mobile-icon u-flex u-flexRow u-flexJustifyBetween u-flexAlignItemsCenter'>
            <button
              className='u-lg-hidden amp-hamburger u-flex u-flexJustifyCenter u-flexAlignItemsCenter u-overflowHidden'
              onClick={handlePopoverClick}
              aria-expanded={popover}>
              {popover ? (
                <i>
                  <span aria-hidden='true' className={`Icon u-textSizeMsrp4 ${textColor}`}>
                    &#xe5cd;
                  </span>
                  <span className={`u-hiddenVisually ${textColor}`}>Close Menu</span>
                </i>
              ) : (
                <div className='u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsCenter u-sizeFull'>
                  <div className='amp-hamburger-icon'>
                    <div aria-hidden='true' className={`${textColor}`}>
                      <div
                        className={`amp-hamburger-icon-dash u-marginTop1gu u-marginBottom1gu ${menuIconColor}`}>
                        &nbsp;
                      </div>
                      <div
                        className={`amp-hamburger-icon-dash u-marginTop1gu u-marginBottom1gu ${menuIconColor}`}>
                        &nbsp;
                      </div>
                      <div
                        className={`amp-hamburger-icon-dash u-marginTop1gu u-marginBottom1gu ${menuIconColor}`}>
                        &nbsp;
                      </div>
                    </div>
                    <span className={`u-hiddenVisually ${textColor}`}>MENU</span>
                  </div>
                  <div
                    className={`amp-hamburger-label u-textSizeMsrm2 ${textColor}`}
                    data-qa='HamburgerMenu'>
                    MENU
                  </div>
                </div>
              )}
            </button>
            <a href='/' className='u-linkClean'>
              <img className='' alt='ameriprise logo' src={desktopImage ?? headerLogo} />
            </a>
            {mobileButton && (
              <a
                href={mobileButton.href}
                className='u-lg-hidden Link Link--external'
                target='_blank'
                data-tracking='Link'
                data-analytics={mobileButton.analytics}>
                {mobileButton.text}
              </a>
            )}
            <div className='header--Buttons u-flex u-flexRow u-flexJustifyBetween u-flexAlignItemsCenter u-textSizeMsrm1 u-sm-hidden u-md-hidden'>
              {siteName && siteNameHref && (
                <div className={`u-marginHoriz3gu ${textColor}`}>
                  <a
                    className={`u-linkClean ${textColor}`}
                    href={siteNameHref}
                    data-analytics={siteName}>
                    {siteName}
                  </a>
                </div>
              )}
              {getRightSideContent()}
            </div>
          </div>
        </div>
      </header>
      {breadCrumbs &&
        breadCrumbs?.currentPageParams?.breadcrumbDisable !== 'true' &&
        breadCrumbs?.breadCrumbs.length !== 0 && (
          <nav className='breadcrumbs u-lg-hidden u-md-paddingHoriz2gu u-sm-paddingLeft3gu'>
            <ul>
              {breadCrumbs.breadCrumbs.map(breadCrumb => (
                <>
                  <span
                    aria-hidden='true'
                    className='Icon u-textSizeMsrm1 List-item u-paddingVert2gu u-paddingHoriz2gu'>
                    &#xe314;
                  </span>
                  <li className='u-textSizeMsrm1 List-item u-paddingVert2gu u-paddingHoriz0'>
                    <a
                      href={breadCrumb.pageURL}
                      className={`u-textSizeMsrm1 ${
                        breadCrumbs?.currentPageParams.breadcrumbReverse === 'true' &&
                        'u-textColorWhite'
                      }`}>
                      {breadCrumb.pageName}
                    </a>
                  </li>
                </>
              ))}
            </ul>
          </nav>
        )}
      {popover && (
        <MobileNavigation
          menuItems={menuItems}
          onClick={() => {
            setPopover(false)
          }}
        />
      )}
    </>
  )
}

export default Header
